var _line, _line2, _line3, _line4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlankLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 109,
    viewBox: "0 0 207 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.1637,
    y1: 79.702,
    x2: 4.70195,
    y2: 106.836,
    stroke: "url(#paint0_linear_33174_29093)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 204.164,
    y1: 2.70196,
    x2: 152.702,
    y2: 29.8363,
    stroke: "url(#paint1_linear_33174_29093)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 60.1772,
    y2: -2,
    transform: "matrix(0.884569 0.466409 0.466409 -0.884569 150 77)",
    stroke: "url(#paint2_linear_33174_29093)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 60.1772,
    y2: -2,
    transform: "matrix(0.884569 0.466409 0.466409 -0.884569 2 0)",
    stroke: "url(#paint3_linear_33174_29093)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33174_29093",
    x1: 57.0001,
    y1: 79.0001,
    x2: 5.00002,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33174_29093",
    x1: 150,
    y1: 29,
    x2: 211,
    y2: -2.99995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33174_29093",
    x1: 0.932806,
    y1: -1.7693,
    x2: 59.5235,
    y2: -1.39928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33174_29093",
    x1: 62.1772,
    y1: -0.0000556275,
    x2: -6.70664,
    y2: -0.1448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankLines);
export default __webpack_public_path__ + "static/media/blank-lines.31c4c721fde575a177ba36fc4b05ecdc.svg";
export { ForwardRef as ReactComponent };